import { tt, Realm } from "./Lang";

export function homePage(realm: Realm) {
  const { game, lang } = realm;
  const t = tt.bind(null, lang);

  const title = {
    en: `Lineage 2 ${game.toUpperCase()} Database - L2Hub.info`,
    ru: `База знаний Lineage 2 ${game.toUpperCase()} - L2Hub.info`,
  };

  return t(title);
}
